import * as React from "react"

function MoonIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={25} width={25} {...props}>
      <circle cx={255.998} cy={256} r={255.998} fill="#415870" />
      <path
        d="M354.157 304.01c-55.434 27.225-122.497 4.111-149.33-51.642-26.027-54.08-3.994-119.768 49.389-147.197.701-.36 1.404-.713 2.109-1.056 4.928-2.403 3.601-9.807-1.852-10.381-26.195-2.759-53.468 1.663-78.817 14.3-69.893 34.842-99.07 120.192-65.129 190.527 34.604 71.709 120.917 101.418 192.267 66.376 25.121-12.338 45.018-31.052 58.708-53.231 2.913-4.719-2.194-10.237-7.168-7.784l-.177.088z"
        fill="#feaf62"
      />
      <g fill="#62788e">
        <path d="M220.883 106.341c0 18.756-15.203 33.959-33.959 33.959l-100.717-1.045c-9.383 0-17.868 3.803-24.012 9.947s-9.947 14.628-9.947 24.012c0 18.756 15.203 33.959 33.959 33.959h38.661c9.383 0 17.868 3.803 24.012 9.947 6.144 6.144 9.947 14.628 9.947 24.012 0 18.756-15.203 33.959-33.959 33.959H6.795c-2.09 0-4.138-.188-6.123-.554a253.312 253.312 0 01-.669-18.536c0-72.348 30.009-137.685 78.273-184.246l108.648.627c18.756 0 33.959 15.203 33.959 33.959zM512 256.001c0 38.912-8.683 75.807-24.221 108.836a33.862 33.862 0 01-21.211-9.832c-6.144-6.144-9.947-14.629-9.947-24.012 0-18.756-15.203-33.959-33.959-33.959h-38.661c-9.383 0-17.868-3.803-24.012-9.947-6.144-6.144-9.947-14.628-9.947-24.012 0-18.756 15.203-33.959 33.959-33.959h38.661c9.383 0 17.868-3.803 24.012-9.947 6.144-6.144 9.947-14.628 9.947-24.012 0-18.756 15.203-33.959 33.959-33.959l3.302.021C505.574 190.539 512 222.523 512 256.001z" />
      </g>
      <g fill="#e8e4db">
        <circle cx={355.932} cy={100.907} r={8.882} />
        <circle cx={316.748} cy={182.92} r={8.882} />
        <circle cx={384.666} cy={414.353} r={8.882} />
        <circle cx={252.498} cy={39.781} r={8.882} />
        <circle cx={232.123} cy={356.372} r={8.882} />
        <circle cx={104.249} cy={374.647} r={8.882} />
        <circle cx={159.315} cy={447.675} r={8.882} />
        <circle cx={316.613} cy={336.478} r={8.882} />
        <circle cx={176.096} cy={190.82} r={8.882} />
      </g>
      <path
        d="M421.759 143.221a93.037 93.037 0 0027.961-6.3 93.105 93.105 0 00-27.961-6.3 93.037 93.037 0 00-6.3-27.961 93.105 93.105 0 00-6.3 27.961 93.037 93.037 0 00-27.961 6.3 93.105 93.105 0 0027.961 6.3 93.037 93.037 0 006.3 27.961 93.044 93.044 0 006.3-27.961z"
        fill="#feaf62"
      />
    </svg>
  )
}

export default MoonIcon
